import React, { useContext } from "react";

import GameContext from "../Context";
import GameLinks from "../Links";
import GameScoreFrame from "../ScoreFrame/ScoreFrame";
import GameTallyCounts from "../TallyCounts";
import { useHistory } from "react-router-dom";
import GameCopyright from "../Copyright";

import ballCorrect from "./legend-ball-correct.png";
import ballWrong from "./legend-ball-wrong.png";
import ballMissed from "./legend-ball-missed.png";

import "./TallyBoard.scss";

function GameTallyBoard() {
  const { engine } = useContext(GameContext);

  const history = useHistory();

  const onNewGame = () => {
    history.push("/");
  };

  const onShowPaths = () => {
    engine.showAllPaths();
  };

  const onHidePaths = () => {
    engine.removePaths();
  }

  return (
    <div className="tally-board">
      <GameLinks />

      <GameScoreFrame value={engine.getScore()} label="Final score" />

      <GameTallyCounts />

      <div className="legend">
        <img src={ballCorrect} alt="correct" />
        <span>correct</span>
        <img src={ballWrong} alt="incorrect" />
        <span>incorrect</span>
        <img src={ballMissed} alt="missed" />
        <span>missed</span>
      </div>

      <div className="button-bar">
        {engine.arePathsRevealed() ? (
          <button className="game-button" onClick={onHidePaths}>
            Hide Rays
          </button>
        ) : (
          <button className="game-button" onClick={onShowPaths}>
            Show Rays
          </button>
        )}
        <button className="game-button" onClick={onNewGame}>
          New game
        </button>
      </div>

      <GameCopyright />
    </div>
  );
}

export default GameTallyBoard;
